import { adminApiAxios } from '@/api'

export interface FollowupEligibility {
  eligible: boolean
  missingStatements: boolean
  clarificationTransactions: number
}

export const fetchFollowupEligibility = async (
  userId: number
): Promise<FollowupEligibility> => {
  const res = await adminApiAxios.get<FollowupEligibility>(
    `/finances/api/v2/admin/catch_up_bookkeeping_status/${userId}/followup_eligibility`
  )
  return res.data
}
